<div>
  <ms-database-user *ngIf="action === dataBaseViewActions.DATABASE_USERS"></ms-database-user>
  <ms-database-group *ngIf="action === dataBaseViewActions.DATABASE_GROUPS"></ms-database-group>
</div>
